import { useLocation, useParams } from "react-router-dom";
import Axios from "../../../utils/axios";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import DropDownList from "../../../components/Atomos/DropDown/Dropdown";
import Input from "../../../components/Atomos/Inputs/Input";
import ButtonsCrud from "../../../components/Catalogs/ButtonsCrud";
import { PhoneNumber } from "../../../components/Atomos/PhoneNumber/PhoneNumber";
import GoBack from "../../../components/Moleculas/GoBack";
import CatalogSubTitle from "../../../components/Moleculas/Catalog Text/CatalogSubTitle";
import SaveOverride from "../../../components/Catalogs/SaveOverride";
import CatalogTitle from "../../../components/Moleculas/Catalog Text/CatalogTitle";
import { getAllCities } from "../../../Services/City";
import {
  firmLongName,
  firmShortLabel,
  firmStoredLongName,
} from "../../../utils/firmDisplayName";
import { getStates } from "../../../Services/State";
import TextArea from "../../../components/Atomos/Inputs/TextArea";
import {
  getCurrentTimestamp,
  getNameById,
} from "../../../utils/functions";
import SwitchToogle from "../../../components/Atomos/Switch-Toogle/Switch";
import {
  defaultShowInDirectory,
  resolveRewriteOfficeMembershipType,
} from "../../../utils/officeRewriteDefaults";
import { IOfficeNew } from "../../../interfaces/models/IOffice";
import { OfficeTypeEnum } from "../../../Enums/OfficeEnum";
import { IPhoneNumber } from "../../../components/staff/PhoneNumber";
import { UseRegionList } from "../../../hooks/Catalogs/useRegionListOptions";
import { UseCountryList } from "../../../hooks/Catalogs";
import {
  buildJurisdiction,
  formatJurisdiction,
  getJurisdictionLabel,
} from "../../../utils/jurisdiction/structuredJurisdiction";

interface iCatalogProps {
  mode: "add" | "edit";
}

type error = { error: boolean; msj: string };
type errors = {
  name: error;
  jurisdiction: error;
  address: error;
  country: error;
  state: error;
  city: error;
  officeType: error;
  phoneNumber: error;
  firm: error;
  yearFounded: error;
};
const currentYear = new Date().getFullYear();

/** Form state includes legacy/API fields not present on IOfficeNew. */
type OfficeFormState = IOfficeNew & {
  name?: string;
  addressName?: string;
};

const EMPTY_OFFICE: OfficeFormState = {
  name: "",
  officeType: "main" as OfficeTypeEnum,
  countOfPeople: 0,
  jurisdiction: "",
  firm: "",
  firmName: "",
  address: "",
  city: "",
  cityName: "",
  country: "",
  countryName: "",
  createdDate: 0,
};

const AddOffice: React.FC<iCatalogProps> = (props) => {
  const axios = new Axios();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { state } = useLocation();
  const [office, setOffice] = useState<OfficeFormState>(
    state ? { ...state } : { ...EMPTY_OFFICE },
  );

  const [errors, setErrors] = useState<errors>({
    name: { error: false, msj: "" },
    jurisdiction: { error: false, msj: "" },
    address: { error: false, msj: "" },
    country: { error: false, msj: "" },
    state: { error: false, msj: "" },
    city: { error: false, msj: "" },
    officeType: { error: false, msj: "" },
    phoneNumber: { error: false, msj: "" },
    firm: { error: false, msj: "" },
    yearFounded: { error: false, msj: "" },
  });

  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [saveOverrideOpen, setSaveOverrideOpen] = useState(false);
  const [buttonClicked, setButtonClicked] = useState("");
  const [firmMainOfficeCount, setfirmMainOfficeCount] = useState(0);

  const [cityData, setCityData] = useState<any[]>([]);
  const [stateData, setStateData] = useState<any[]>([]);
  const [addressData, setAddressData] = useState<any[]>([]);
  const [firmData, setFirmData] = useState<any[]>([]);
  const [officeData, setOfficeData] = useState<any[]>([]);
  const [selectedOfficeType, setSelectedOfficeType] = useState(
    state?.officeType ?? "",
  );
  const [selectedCountry, setSelectedCountry] = useState({ id: "", name: "" });
  const [selectedCity, setSelectedCity] = useState({
    id: "",
    name: "",
    countryName: "",
  });
  const [selectedState, setSelectedState] = useState({ id: "", name: "" });
  const [selectedAddress, setSelectedAddress] = useState({ id: "", name: "" });
  const [selectedFirm, setSelectedFirm] = useState<{
    id: string;
    name: string;
    longName?: string;
  }>({ id: "", name: "" });
  const [faxNumber, setFaxNumber] = useState<IPhoneNumber>(
    state?.faxNumber ? state.faxNumber : { code: "", phone: "", basecode: "" },
  );
  const [phoneNumber, setPhoneNumber] = useState<IPhoneNumber>(
    state?.phoneNumber
      ? state.phoneNumber
      : { code: "", phone: "", basecode: "" },
  );
  const [people, setPeople] = useState<string>("");
  const [overview, setOverview] = useState<string>(state?.overview || "");
  const [mainFirmOverview, setMainFirmOverview] = useState(false);
  const [regionName, setRegionName] = useState<string>("");
  const { regionData } = UseRegionList();
  const { countryData } = UseCountryList();

  const officeJurisdiction = useMemo(
    () =>
      buildJurisdiction(
        {
          countryName: selectedCountry?.name,
          stateName: selectedState.name,
          stateAbbreviation: stateData.find(
            (s: { id: string }) => s.id === selectedState.id,
          )?.abbreviation,
          city: selectedCity.name,
        },
        "office",
      ),
    [
      selectedCountry?.name,
      selectedState.id,
      selectedState.name,
      selectedCity.name,
      stateData,
    ],
  );

  const jurisdictionPreview = officeJurisdiction
    ? formatJurisdiction(officeJurisdiction)
    : getJurisdictionLabel(state ?? {});

  const getProfessionalsCount = async () => {
    try {
      const response = await axios.Get("/person");
      if (response && response.data) {
        const filtered = response.data.filter(
          (person: any) => person.mainOffice === office.id,
        ).length;
        setPeople(filtered?.toString());
      }
    } catch (error) {}
  };

  useEffect(() => {
    getProfessionalsCount();
  }, [office]);

  useEffect(() => {
    if (!countryData.length || !state?.country) {
      return;
    }
    const _selectedCountry = countryData.find(
      (country: any) => country.id === state.country,
    );
    setSelectedCountry(_selectedCountry);
    setRegionName(
      getNameById(
        _selectedCountry.regions.map((r: any) => r.id),
        regionData,
      ).join(", "),
    );
  }, [countryData, state]);

  useEffect(() => {
    if (selectedState.id) {
      getAllCities().then((data) => {
        if (data != null) {
          const newCities = data.filter(
            (item: any) => item.state === selectedState.id,
          );
          setCityData(newCities);
        }
      });
    }
  }, [selectedState.id]);

  function transformAddressData(newAddress: any) {
    return newAddress.map((address: any) => {
      return {
        ...address,
        name: address ? address.address1 : null,
      };
    });
  }

  useEffect(() => {
    if (!selectedState.id && stateData.length > 0) {
      const filteredState = stateData.find(
        (stateOffice: any) => stateOffice.name === state?.stateName,
      );
      if (filteredState) {
        setSelectedState({ id: filteredState.id, name: filteredState.name });
      } else {
        console.warn("No matching state found");
      }
    }
  }, [selectedState, stateData]);

  useEffect(() => {
    const fetchAddresses = async () => {
      let queryString = "/address";
      queryString +=
        selectedCity.id === ""
          ? ""
          : "?&cities=" + JSON.stringify([selectedCity.id]);
      const res = await axios.Get(queryString);
      const newData = transformAddressData(res.data);
      const newAddresses = newData.filter(
        (item: any) => item.city === selectedCity.id,
      );
      setAddressData(newAddresses);

      const filteredAddress = newData.find(
        (address: any) => address.id === state?.address,
      );
      if (filteredAddress) {
        setSelectedAddress({
          id: filteredAddress.id,
          name: filteredAddress.name,
        });
      }
    };

    if (selectedCity.id !== "") {
      fetchAddresses();
    }
  }, [selectedCity]);

  useEffect(() => {
    if (
      errors.firm.error ||
      errors.name.error ||
      errors.country.error ||
      errors.state.error ||
      errors.city.error ||
      errors.address.error ||
      errors.jurisdiction.error ||
      errors.officeType.error ||
      errors.phoneNumber.error
    ) {
      validateForm();
    }
  }, [
    office,
    selectedOfficeType,
    selectedCity,
    selectedCountry,
    selectedState,
    selectedFirm,
    selectedAddress,
    phoneNumber,
  ]);

  useEffect(() => {
    if (
      !errors.firm.error &&
      !errors.name.error &&
      !errors.country.error &&
      !errors.state.error &&
      !errors.city.error &&
      !errors.address.error &&
      !errors.jurisdiction.error &&
      !errors.officeType.error &&
      !errors.phoneNumber.error
    ) {
      setSaveOverrideOpen(false);
    }
  }, [errorFields]);

  useEffect(() => {
    if (officeData.length === 0) {
      const fetchOfficeData = async () => {
        try {
          const response = await axios.Get("./office");
          const data = response.data;
          if (data != null) {
            setOfficeData(data);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchOfficeData();
    }

    const fetchFirms = async () => {
      const res = await axios.Get("/firm?withWSG=true");
      const firms = (res.data || []).map((firm: any) => ({
        ...firm,
        longName: firmLongName(firm),
        name: firmShortLabel(firm) || firmLongName(firm),
      }));
      setFirmData(firms);
      const filteredFirm = firms.find(
        (firm: any) => firm.id === state?.firm,
      );
      setSelectedFirm({
        id: filteredFirm?.id || "",
        name: filteredFirm?.name || "",
        longName: filteredFirm?.longName || "",
      });
    };

    const fetchCities = async () => {
      const res = await axios.Get("/city");
      if (res.data) {
        setCityData(res.data);
        const filteredCountry = res.data.find(
          (country: any) => country.id === state?.city,
        );
        setSelectedCity({
          id: filteredCountry?.id ?? "",
          name: filteredCountry?.name ?? "",
          countryName: filteredCountry?.countryName ?? "",
        });
      }
    };

    setErrors({
      name: { error: false, msj: "" },
      jurisdiction: { error: false, msj: "" },
      address: { error: false, msj: "" },
      country: { error: false, msj: "" },
      state: { error: false, msj: "" },
      city: { error: false, msj: "" },
      officeType: { error: false, msj: "" },
      phoneNumber: { error: false, msj: "" },
      firm: { error: false, msj: "" },
      yearFounded: { error: false, msj: "" },
    });

    fetchFirms();
    fetchCities();
  }, []);

  const fetchStates = async () => {
    try {
      const states = await getStates();
      if (states) {
        const newStates = states.filter(
          (item: any) => item.country === selectedCountry.id,
        );
        setStateData(newStates);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  useEffect(() => {
    if (selectedCountry.id) {
      fetchStates();
    }
  }, [selectedCountry]);

  const validateForm = () => {
    let valid = true;
    let newerrors: errors = errors;
    const firm = firmData.find((firm: any) => firm.id === selectedFirm.id);
    const editFirm = props.mode === "edit" ? state.firmId : "";

    if (selectedOfficeType === "Main") {
      if (firm) {
        if (
          firm.membershipType === "Primary" &&
          editFirm !== selectedFirm.id &&
          firmMainOfficeCount > 0
        ) {
          newerrors.officeType = {
            error: true,
            msj: "Main Offices for this firm has reached its limit. Please change the Office Type.",
          };
        } else {
          newerrors.officeType = { error: false, msj: "" };
        }
      } else {
        newerrors.officeType = {
          error: true,
          msj: "Firm is required to be selected.",
        };
      }
    } else if (selectedOfficeType === "" || selectedOfficeType === null) {
      newerrors.officeType = { error: true, msj: "Office Type is required" };
    } else {
      newerrors.officeType = { error: false, msj: "" };
    }

    newerrors.firm =
      selectedFirm.name === ""
        ? { error: true, msj: "Firm is required" }
        : { error: false, msj: "" };
    newerrors.name =
      !String(office.name ?? "").trim()
        ? { error: true, msj: "Name is required" }
        : { error: false, msj: "" };
    newerrors.country =
      selectedCountry.name === ""
        ? { error: true, msj: "Country is required" }
        : { error: false, msj: "" };
    newerrors.state =
      stateData.length > 0 && selectedState.name === ""
        ? { error: true, msj: "State is required" }
        : { error: false, msj: "" };
    newerrors.city =
      cityData.length > 0 && selectedCity.name === ""
        ? { error: true, msj: "City is required" }
        : { error: false, msj: "" };
    newerrors.address =
      selectedAddress.name === ""
        ? { error: true, msj: "Address is required" }
        : { error: false, msj: "" };
    newerrors.jurisdiction = !officeJurisdiction
      ? {
          error: true,
          msj: "Jurisdiction is required. Select a country with an ISO code, state and city.",
        }
      : { error: false, msj: "" };
    newerrors.phoneNumber =
      phoneNumber.phone?.trim() === "" ||
      phoneNumber.code === "" ||
      phoneNumber.code === undefined
        ? { error: true, msj: "Phone Number is required" }
        : { error: false, msj: "" };
    newerrors.yearFounded =
      !office.yearFounded ||
      ((office.yearFounded ?? 0) > 1800 &&
        (office.yearFounded ?? 0) < currentYear)
        ? { error: false, msj: "" }
        : { error: true, msj: `Year must be between 1800 and ${currentYear}` };

    setErrors(newerrors);

    // Verifica si todos los campos son válidos
    valid = Object.values(newerrors).every((error) => !error.error);
    setErrorFields(
      Object.keys(newerrors).filter(
        (key) => newerrors[key as keyof typeof newerrors].error,
      ),
    );

    // Si no es válido, abre el modal de sobreescritura de guardado
    if (!valid) {
      setSaveOverrideOpen(true);
    }

    return valid;
  };

  const handleButtonClick = (action: string) => {
    setButtonClicked(action);
  };

  useEffect(() => {
    if (!firmData.length || !selectedFirm.id) {
      return;
    }
    const firm = firmData.find((firm) => firm.id === selectedFirm.id);
    if (firm) {
      const officesInFirm = officeData.filter(
        (office: any) =>
          office.officeType !== "Additional" && office.firmId === firm.id,
      );
      setfirmMainOfficeCount(officesInFirm.length);
    }
  }, [selectedFirm, firmData, officeData]);

  const handleDelete = async (id: string) => {
    const response = await axios.Delete(`/Office`, id);

    if (response.status === 200) {
      navigate(-1);
    } else {
      console.error("Error al eliminar el elemento:", response.data);
    }
  };

  const handleChangePhone = (obj: any) => {
    setPhoneNumber({
      code: obj.code,
      phone: obj.phone,
      basecode: obj.basecode,
    });
  };

  const handleChangeFax = (obj: any) => {
    setFaxNumber({ code: obj.code, phone: obj.phone, basecode: obj.basecode });
  };

  const handleChangeMainFirmOverview = () => {
    if (!mainFirmOverview) {
      officeData?.forEach((row) => {
        if (row.firm === selectedFirm?.id && row.officeType === "Main") {
          setOverview(row.overview);
        }
      });
    } else {
      setOverview("");
    }

    setMainFirmOverview(!mainFirmOverview);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (buttonClicked === "delete") {
      axios.Delete("office", office.id ?? "").then(() => {
        navigate(-1);
      });
    } else if (buttonClicked === "saveOverride") {
      if (props.mode === "add") {
        handleSave(e);
      } else {
        handleUpdate(e);
      }
    } else if (validateForm()) {
      if (buttonClicked === "saveButton") {
        handleSave(e);
      } else if (buttonClicked === "updateButton") {
        handleUpdate(e);
      }
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    setOffice({ ...office, [e.target.name]: e.target.value });
  };

  const buildOfficeObjet = (): OfficeFormState => {
    const officeType = selectedOfficeType;
    const existingMembershipType =
      (office as { membershipType?: string }).membershipType ??
      (state as { membershipType?: string } | null)?.membershipType;
    const existingShowInDirectory =
      (office as { showInDirectory?: boolean }).showInDirectory ??
      (state as { showInDirectory?: boolean } | null)?.showInDirectory;

    return {
      ...state,
      ...office,
      name: String(office.name ?? "").trim(),
      officeType,
      membershipType: resolveRewriteOfficeMembershipType(
        officeType,
        existingMembershipType,
      ) as OfficeFormState["membershipType"],
      showInDirectory: defaultShowInDirectory(existingShowInDirectory),
      countOfPeople: Number(office.countOfPeople) || 0,
      jurisdiction: officeJurisdiction ?? office.jurisdiction,
      firm: selectedFirm.id,
      firmName: firmStoredLongName(selectedFirm),
      address: selectedAddress.id,
      addressName: selectedAddress.name,
      city: selectedCity.id,
      cityName: selectedCity.name,
      country: selectedCountry.id,
      countryName: selectedCountry.name,
      state: selectedState.id,
      stateName: selectedState.name,
      phoneNumber,
      faxNumber,
      yearFounded: Number(office.yearFounded) || undefined,
      overview,
      regionName,
      createdDate: state?.createdDate ?? office.createdDate,
    };
  };

  const handleSave = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const officePayload = buildOfficeObjet();
    officePayload.createdDate = getCurrentTimestamp();
    const res = await axios.Post("Office", officePayload);
    if (res.status === 200) {
      if (res.data.error) {
        if (res.data.error[0].includes("Address")) {
          setErrors({
            ...errors,
            address: {
              error: true,
              msj: "Address is already assigned to an Office. Please select a different one.",
            },
          });
        }
        if (res.data.error[0].includes("Name")) {
          setErrors({
            ...errors,
            name: {
              error: true,
              msj: "Name is already assigned to an Office. Please select a different one.",
            },
          });
        }
      } else {
        setTimeout(() => {
          navigate(-1);
        }, 500);
      }
    } else {
      console.error(res.data);
    }
  };

  const handleUpdate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const newOffice = buildOfficeObjet();
    await axios.Put("Office", newOffice).then((res) => {
      if (res.status === 200) {
        if (res.data.error) {
          if (
            res.data.error[0].includes("Address") ||
            res.data.error[0].includes("Duplicate")
          ) {
            setErrors({
              ...errors,
              address: {
                error: true,
                msj: "Address is already assigned to an Office. Please select a different one.",
              },
            });
          }
        }
      } else {
        console.error(res.data);
      }
    });
  };

  const handleSetSelectedCountry = async (e: any) => {
    setSelectedCountry(e);
    if (e.id !== selectedCountry.id) {
      setSelectedState({ id: "", name: "" });
      setSelectedCity({ id: "", name: "", countryName: "" });
      setSelectedAddress({ id: "", name: "" });
    }
  };

  const handleSetSelectedState = (e: any) => {
    setSelectedState(e);
    // Reiniciar la ciudad solo si se cambia el estado
    if (e.id !== selectedState.id) {
      setSelectedCity({ id: "", name: "", countryName: "" });
      setSelectedAddress({ id: "", name: "" });
    }
  };

  const handleSetSelectedFirm = (e: any) => {
    setSelectedFirm(e);
    setOffice({ ...office, firm: e.id });
  };

  const handleSetSelectedCity = (e: any) => {
    setSelectedCity(e);
    setSelectedAddress({ id: "", name: "" });
    setOffice({ ...office, city: e.id });
  };

  const handleSetSelectedAddress = (e: any) => {
    setSelectedAddress(e);
    setOffice({ ...office, address: e.id });
  };

  const handleSetSelectedOfficeType = (e: any) => {
    setSelectedOfficeType(e);
    setOffice({ ...office, officeType: e });
  };

  const handleOverviewChange = (e: any) => {
    setOverview(e.target.value);
  };

  return (
    <>
      <main className={`${saveOverrideOpen ? "pt-7 md:pt-9 " : ""}`}>
        <form onSubmit={handleSubmit}>
          <SaveOverride
            fields={errorFields}
            handleButtonClick={handleButtonClick}
            open={saveOverrideOpen}
            close={() => {
              setSaveOverrideOpen(!saveOverrideOpen);
            }}
          />
          <CatalogTitle
            title={`${props.mode === "add" ? "New Office" : `Edit ${state?.name || ""}`}`}
            className="text-Default"
          >
            <GoBack />
          </CatalogTitle>
          <article className="articleSection">
            <section className="formsectionNTitle">
              <CatalogSubTitle
                title=" Catalog List Relationships"
                className="text-accent-Default-dark"
              />
              <div className="formsection grid grid-cols-12 gap-5 w-full">
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-4">
                  <DropDownList
                    title="Firm"
                    required={true}
                    data={firmData}
                    selectedObjst={selectedFirm.name}
                    seter={handleSetSelectedFirm}
                    error={errors.firm.error}
                    errormsj={errors.firm.msj}
                    getid
                  />
                </div>
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-4">
                  <Input
                    title="Jurisdiction"
                    name="jurisdiction"
                    required
                    disabled
                    error={errors.jurisdiction.error}
                    errorMsj={errors.jurisdiction.msj}
                    value={jurisdictionPreview}
                  />
                </div>
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-3">
                  <DropDownList
                    title="Country"
                    required={true}
                    data={countryData}
                    selectedObjst={selectedCountry.name}
                    seter={handleSetSelectedCountry}
                    error={errors.country.error}
                    errormsj={errors.country.msj}
                    getid
                  />
                </div>
                {stateData.length > 0 ? (
                  <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-3">
                    <DropDownList
                      title="State"
                      required={true}
                      disabled={selectedCountry.name === ""}
                      data={stateData}
                      selectedObjst={selectedState.name}
                      seter={handleSetSelectedState}
                      error={errors.state.error}
                      errormsj={errors.state.msj}
                      getid
                    />
                  </div>
                ) : null}
                {cityData.length > 0 ? (
                  <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-3">
                    <DropDownList
                      title="City"
                      required={true}
                      disabled={selectedState.name === ""}
                      data={cityData}
                      selectedObjst={selectedCity.name}
                      seter={handleSetSelectedCity}
                      error={errors.city.error}
                      errormsj={errors.city.msj}
                      getid
                    />
                  </div>
                ) : null}
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-3">
                  <DropDownList
                    title="Address"
                    required={selectedCity.name !== ""}
                    disabled={selectedCity.name === ""}
                    data={addressData}
                    selectedObjst={selectedAddress.name}
                    seter={handleSetSelectedAddress}
                    error={errors.address.error}
                    errormsj={errors.address.msj}
                    getid
                  />
                </div>
              </div>
            </section>
            <section className="formsectionNTitle">
              <CatalogSubTitle
                title="Office Information"
                className="text-accent-Default-dark"
              />
              <div className="formsection grid grid-cols-12 gap-5 w-full">
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-4">
                  <Input
                    title="Name"
                    name="name"
                    error={errors.name.error}
                    errorMsj={errors.name.msj}
                    value={String(office.name ?? "")}
                    onChange={handleInputChange}
                    required={true}
                  />
                </div>
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-4">
                  <DropDownList
                    title="Office Type"
                    required={true}
                    selectedObjst={selectedOfficeType}
                    seter={handleSetSelectedOfficeType}
                    data={[
                      { id: "Main", name: "Main" },
                      { id: "Additional", name: "Additional" },
                    ]}
                    error={errors.officeType.error}
                    errormsj={errors.officeType.msj}
                  />
                </div>
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-4">
                  <Input
                    title="Professionals in Office"
                    name="countOfPeople"
                    error={false}
                    value={people ? people : office?.countOfPeople?.toString()}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-4">
                  <PhoneNumber
                    title="Phone Number"
                    Obj={phoneNumber}
                    seter={handleChangePhone}
                    required={true}
                    error={errors.phoneNumber.error}
                    errormsj={errors.phoneNumber.msj}
                  />
                </div>
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-4">
                  <PhoneNumber
                    title="Fax Number"
                    error={false}
                    Obj={faxNumber}
                    seter={handleChangeFax}
                  />
                </div>
                <div className="gap-4 flex-wrap col-span-12 md:col-span-6 lg:col-span-4">
                  <Input
                    title="Year Founded"
                    name="yearFounded"
                    error={errors.yearFounded.error}
                    errorMsj={errors.yearFounded.msj}
                    value={office.yearFounded?.toString()}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="w-full">
                <TextArea
                  title="Overview"
                  error={false}
                  onChange={handleOverviewChange}
                  value={overview}
                  characterCount
                  maxChars={3500}
                  disabled={mainFirmOverview}
                />
                <SwitchToogle
                  seter={handleChangeMainFirmOverview}
                  checked={mainFirmOverview}
                  title="Use Main Firms Overview"
                />
              </div>
            </section>
            <ButtonsCrud
              Catalog="Office"
              mode={props.mode}
              id={id ? id : ""}
              disabled={
                errors.firm.error ||
                errors.name.error ||
                errors.country.error ||
                errors.state.error ||
                errors.city.error ||
                errors.address.error ||
                errors.jurisdiction.error ||
                errors.officeType.error ||
                errors.phoneNumber.error
              }
              actionButton={handleButtonClick}
              onDelete={handleDelete}
              state={state}
              newState={buildOfficeObjet()}
              customFieldNames={{
                "phoneNumber.phone": "Phone Number",
                "faxNumber.phone": "Fax Number",
              }}
            />
          </article>
        </form>
      </main>
    </>
  );
};

export default AddOffice;
